import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
//import { CommonEnums } from 'src/app/shared/common.enums';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class VerticaWrapper extends DatabaseWrapper {

	constructor(database: Database) {
		super(database);

		this.dbTyp_Id = DatabaseEnum.vertica.ID;
		this.name = DatabaseEnum.vertica.NAME;
		this.code = DatabaseEnum.vertica.CODE;
		this.equivalentTag = DatabaseEnum.vertica.EQUIVALENT_TAG;
		//data object tabs
		this.isShowColFormat = true;  //Add by sharmila on 26/04/2024
		this.getSchemasOnDbNm = false;//add by sharmila on 26/04/2024
        this.showDataObjectPropertiesTab = true;  //add by sharmila on 26/04/2024

		this.showExtractPropertiesTab = true;
		this.showLoadPropertiesTab = true;
		this.showDDLOption = true;
		this.hideSchemaNmColumn = false;
		this.showViewDataTabOption = true;
		this.isShowObjProperties = true;
		this.dataObjectConnDatabaseNm = 'Database';
    this.showDataDescription = false;
	}

	validateRepConn(repConnWrapper: RepConnWrapper): void {

		if (repConnWrapper.repConn.conn.host == "") {
			repConnWrapper.inValid_Cds.push('NO_HOST');
		}

		if (repConnWrapper.repConn.conn.port == "") {
			repConnWrapper.inValid_Cds.push('NO_PORT');
		}

		if (repConnWrapper.repConn.conn_Usr.conn_Usr == "") {
			repConnWrapper.inValid_Cds.push('NO_CONN_APPUSR');
		}

		if (repConnWrapper.repConn.conn_Usr.usrPasswd == "") {
			repConnWrapper.inValid_Cds.push('NO_PASSWORD');
		}


		if (repConnWrapper.repConn.conn.authentication == "SSL") {

			if (repConnWrapper.repConn.conn.ssl_keyStore == undefined || repConnWrapper.repConn.conn.ssl_keyStore == "") {
				repConnWrapper.inValid_Cds.push('NO_SSL_KEYSTORE');
			}
			if (repConnWrapper.repConn.conn.ssl_keyStorePassword == undefined || repConnWrapper.repConn.conn.ssl_keyStorePassword == "") {
				repConnWrapper.inValid_Cds.push('NO_SSL_KEYSTOREPWD');

			}
			if (repConnWrapper.repConn.conn.ssl_trustStore == undefined || repConnWrapper.repConn.conn.ssl_trustStore == "") {
				repConnWrapper.inValid_Cds.push('NO_SSL_TRUSTSTORE');
			}
			if (repConnWrapper.repConn.conn.ssl_trustStorePassword == undefined || repConnWrapper.repConn.conn.ssl_trustStorePassword == "") {
				repConnWrapper.inValid_Cds.push('NO_SSL_TRUSTSTOREPWD');
			}
		}
		if (repConnWrapper.repConn.conn.flagent_Id == -1) {
			repConnWrapper.inValid_Cds.push('ESM00202');
		}

		if (repConnWrapper.repConn.conn_Dbs.length < 1) {
			repConnWrapper.inValid_Cds.push('NO_DATABASE');
		}

	}
	///todo  flag as parameter
	getDerivedAttributeColumns(objectWrapper: ObjectWrapper, component: any, isMax: boolean = false, attributes: Array<Attribute> = new Array<Attribute>(), isHiveNative: boolean = false,hideOrderBy): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getMaxFlag(objectWrapper, isMax),
			this.attributeTabulator.getDistKeyFlag(objectWrapper),
			this.attributeTabulator.getOrgKeyFlag(objectWrapper),
			this.attributeTabulator.getOrderBy(objectWrapper, component,hideOrderBy),
			this.attributeTabulator.getPartitionflag(objectWrapper, isHiveNative),
			this.attributeTabulator.getAttrExprVal(objectWrapper, component),
			this.attributeTabulator.getValid_Cd(objectWrapper, component),
		]
	}

	getAttributeColumns(objectWrapper: ObjectWrapper,
		attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getNotNullFlag(objectWrapper),
			this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
			this.attributeTabulator.getDistKeyFlag(objectWrapper, 'Partition'),
			this.attributeTabulator.getOrderBy(objectWrapper, component),
			this.attributeTabulator.getDescription(objectWrapper),
		]
	}

	///
	getSourceAttributeColumns(objectWrapper: ObjectWrapper, isComplex: boolean = false, isShowPIIColumn: boolean = false, isGoogleAnalytics: boolean = false, isEncryptedFlag: boolean = false, isMax: boolean = false, component: any): Array<any> {  // isEncode: boolean = false,
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.attributeTabulator.getSrt_Order(),
			this.attributeTabulator.getAttr_Id(),
			this.attributeTabulator.getClevel(objectWrapper, isComplex),
			this.attributeTabulator.getAttrNm(objectWrapper,component),
			this.attributeTabulator.getAttrDTyp_Id(objectWrapper, objectWrapper.object.attributes, component),
			this.attributeTabulator.getAttrPrec(objectWrapper),
			this.attributeTabulator.getAttrScale(objectWrapper),
			this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, isShowPIIColumn),
			this.attributeTabulator.getEncryptedFlag(objectWrapper, isEncryptedFlag),
			this.attributeTabulator.getDistKeyFlag(objectWrapper, 'Partition'),
			this.attributeTabulator.getOrderBy(objectWrapper, component),
			this.attributeTabulator.getLnk_Attr_Id(objectWrapper),
			this.attributeTabulator.getLnk_Attr_Datatype(objectWrapper),
			this.attributeTabulator.getValid_Cd(objectWrapper, component),
		]
	}

	// getRollupSelectAttributeColumns(objectWrapper: ObjectWrapper): Array<any> {
	// 	return [
	// 		this.attributeTabulator.getCheckBoxColumn(objectWrapper),
	// 		this.lAttributeTabulator.getSrt_Order(),
	// 		this.lAttributeTabulator.getLAttr_Id(),
	// 		this.lAttributeTabulator.getLAttrNm(objectWrapper),
	// 		this.lAttributeTabulator.getSelectColumn(objectWrapper),
	// 		this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
	// 		this.lAttributeTabulator.getLAttrPrec(objectWrapper),
	// 		this.lAttributeTabulator.getLAttrScale(objectWrapper),
	// 		this.lAttributeTabulator.getLAttrType(objectWrapper),
	// 		this.lAttributeTabulator.getLAttrFunction(objectWrapper),
	// 		this.lAttributeTabulator.getDistKeyFlag(objectWrapper),
	// 		this.lAttributeTabulator.getOrgKeyFlag(objectWrapper),
	// 		this.lAttributeTabulator.getPartFlag(objectWrapper),
	// 		this.lAttributeTabulator.getOrderBy(objectWrapper)
	// 	]
	// }

	getLAttributeColumns(objectWrapper: ObjectWrapper, component): Array<any> {
		return [
			this.attributeTabulator.getCheckBoxColumn(objectWrapper),
			this.lAttributeTabulator.getSrt_Order(),
			this.lAttributeTabulator.getLAttr_Id(),
			this.lAttributeTabulator.getLAttrNm(objectWrapper),
			this.lAttributeTabulator.getSelectColumn(objectWrapper),
			this.lAttributeTabulator.getAttrDTypNm(objectWrapper),
			this.lAttributeTabulator.getLAttrPrec(objectWrapper),
			this.lAttributeTabulator.getLAttrScale(objectWrapper),
			this.lAttributeTabulator.getLAttrType(objectWrapper),
			this.lAttributeTabulator.getLAttrFunction(objectWrapper),
			this.lAttributeTabulator.getDistKeyFlag(objectWrapper, component, 'Partition'),
			this.lAttributeTabulator.getOrderBy(objectWrapper, component),
		]
	}

	getConn_DbColumns(repConnWrapper: RepConnWrapper, component): Array<any> {
		return [
			this.conn_DbsTabultor.getCheckBoxColumn(repConnWrapper),
			this.conn_DbsTabultor.getSrt_Order(),
			this.conn_DbsTabultor.getName(repConnWrapper),
			this.conn_DbsTabultor.getDatabaseNm(repConnWrapper, component),
			//this.conn_DbsTabultor.getSchemaNm(repConnWrapper, component), //add by sharmila on 26-04-2024
            this.conn_DbsTabultor.getStgDb_Flag(repConnWrapper) //add by sharmila on 26-04-2024
		]
	}
}
